/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  Group,
  Modal,
  Select,
  Text,
  Textarea,
} from "@mantine/core";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import {
  deleteTemplateTextbox,
  updateTemplateTextbox,
} from "@/graphql/mutations";
import {
  DeleteTemplateTextboxInput,
  DeleteTemplateTextboxMutation,
  DeleteTemplateTextboxMutationVariables,
  UpdateTemplateTextboxInput,
  UpdateTemplateTextboxMutation,
  UpdateTemplateTextboxMutationVariables,
} from "@/API";

const client = generateClient();

type editTextBoxTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  textbox: any;
  fetchTemplate: (templateId: string) => void;
};

const EditTextBoxTemplateModal = (props: editTextBoxTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template, textbox } =
    props;
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sections, setSections] = useState();
  const [sectionId, setSectionId] = useState<any>();
  const [fieldValue, setFieldValue] = useState("");
  const defaultValueRef = useRef(null);

  useEffect(() => {
    if (!template?.sections) {
      return;
    }
    const initSections = template.sections.items
      .filter((section: any) => section.isSimple === true)
      ?.map((section: any) => {
        return { value: section.id, label: section.name };
      });
    if (initSections?.length > 0) {
      setSections(initSections);
      setSectionId(initSections[0].value);
    }
  }, [template]);

  useEffect(() => {
    if (textbox?.id) {
      setFieldValue(textbox.value);
      setSectionId(textbox.sectionId);
    }
  }, [textbox]);

  const handleEditTextBox = async () => {
    if (fieldValue === "" || sectionId === "") {
      setErrorMsg("Please provide a default value and section");
      return;
    }
    setErrorMsg("");
    setIsLoading(true);
    try {
      try {
        const updateTextboxInput: UpdateTemplateTextboxInput = {
          id: textbox.id,
          _version: textbox._version,
          value: fieldValue,
          sID: sectionId,
        };

        const updateTextboxVars: UpdateTemplateTextboxMutationVariables = {
          input: updateTextboxInput,
        };

        const updateTextboxResult = await client.graphql<
          GraphQLQuery<UpdateTemplateTextboxMutation>
        >({ query: updateTemplateTextbox, variables: updateTextboxVars });
        console.log(updateTextboxResult);
      } catch (err) {
        console.log("error edit textbox:", err);
      }
      setIsLoading(false);
      fetchTemplate(template.id);
      closeAndResetModal();
    } catch (err) {
      console.log("error edit textbox:", err);
      setIsLoading(false);
    }
  };

  const handleDeleteTextBox = async () => {
    try {
      setIsLoading(true);
      const deleteTextboxInput: DeleteTemplateTextboxInput = {
        id: textbox.id,
        _version: textbox._version,
      };

      const deleteTextboxInputVars: DeleteTemplateTextboxMutationVariables = {
        input: deleteTextboxInput,
      };

      const deleteTextboxResponse = await client.graphql<
        GraphQLQuery<DeleteTemplateTextboxMutation>
      >({ query: deleteTemplateTextbox, variables: deleteTextboxInputVars });
      console.log(deleteTextboxResponse);
      fetchTemplate(template.id);
    } catch (err) {
      console.log("error deleting Textbox:", err);
    }
    setIsLoading(false);
    closeAndResetModal();
  };

  const handleInsertInput = async () => {
    const inputMaster = "#INPUT#";
    const textarea: any = defaultValueRef.current;
    const { selectionStart, selectionEnd }: any = textarea;
    const newText =
      fieldValue.substring(0, selectionStart) +
      inputMaster +
      fieldValue.substring(selectionEnd);
    setFieldValue(newText);
    textarea.focus();
  };

  const closeAndResetModal = () => {
    setModalOpened(false);
    setErrorMsg("");
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={closeAndResetModal}
      title="Edit textbox"
    >
      <Flex flex={1} align={"center"} justify={"space-between"}>
        <Text>Default value</Text>
        <Button variant="transparent" p={0} onClick={handleInsertInput}>
          Insert input
        </Button>
      </Flex>
      <Textarea
        label=""
        ref={defaultValueRef}
        placeholder="Enter default value"
        value={fieldValue}
        minRows={4}
        onChange={(event) => setFieldValue(event.target.value)}
        autosize
        resize="vertical"
      />
      {errorMsg && (
        <Text fz={14} fw={400} c={"red"}>
          {errorMsg}
        </Text>
      )}
      <Select
        placeholder="Select section"
        label="Section"
        data={sections}
        value={sectionId}
        onChange={(_value, option) => setSectionId(option.value)}
      />
      <Group mt="md">
        <Group mt="md">
          <Button loading={isLoading} onClick={handleEditTextBox}>
            Save
          </Button>
          <Button color="red" loading={isLoading} onClick={handleDeleteTextBox}>
            Delete
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default EditTextBoxTemplateModal;
